import React from "react";
import { Avatar } from "antd";

const UserInfo = ({ uid, email, firstName, lastName, logout }) => {
  return (
    <div
      onClick={() => {
        logout();
      }}
      className="hidden flex-initial lg:flex items-center bg-gray-100 px-3 py-2 rounded-lg cursor-pointer shadow-sm hover:shadow-none"
    >
      <div className="flex flex-col items-end mr-3">
        <p
          style={{ maxWidth: "8rem" }}
          className="truncate m-0 p-0 font-semibold tracking-wide leading-none text-gray-700"
        >
          {`${firstName.toUpperCase()} ${lastName.toUpperCase()}`}
        </p>
        <p
          style={{ maxWidth: "8rem" }}
          className="truncate m-0 p-0 text-gray-500 text-xs leading-none mt-1 blue"
        >
          {email}
        </p>
      </div>
      <Avatar
        style={{
          verticalAlign: "middle",
          backgroundColor: "rgb(99, 179, 237)",
        }}
        size="large"
        gap={10}
      >
        {`U${uid}`}
      </Avatar>
    </div>
  );
};

export default UserInfo;
